/**
 * Cookie consent state + Google Consent Mode v2 bridge.
 * Default consent ("denied") is set inline in public/index.html before any tag loads;
 * this module persists the visitor's choice and pushes `consent update` to gtag.
 */
export const CONSENT_KEY = "hcm_consent";
export const CONSENT_VERSION = 1;
const GA4_ID = process.env.REACT_APP_GA4_ID;

export function getConsent() {
  try {
    const c = JSON.parse(localStorage.getItem(CONSENT_KEY) || "null");
    return c && c.v === CONSENT_VERSION ? c : null;
  } catch {
    return null;
  }
}

function gtag() {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(arguments);
}

function pushConsentUpdate({ analytics, marketing }) {
  gtag("consent", "update", {
    analytics_storage: analytics ? "granted" : "denied",
    ad_storage: marketing ? "granted" : "denied",
    ad_user_data: marketing ? "granted" : "denied",
    ad_personalization: marketing ? "granted" : "denied",
  });
}

export function saveConsent({ analytics, marketing }) {
  const record = { v: CONSENT_VERSION, analytics: !!analytics, marketing: !!marketing, at: new Date().toISOString() };
  localStorage.setItem(CONSENT_KEY, JSON.stringify(record));
  pushConsentUpdate(record);
  window.dispatchEvent(new CustomEvent("hcm:consent", { detail: record }));
  return record;
}

/** Re-open the banner in "configure" mode (used by the footer link). */
export function openConsentSettings() {
  window.dispatchEvent(new CustomEvent("hcm:consent-open"));
}

/** Loads gtag.js once when a GA4 id is configured. Consent Mode keeps it cookieless until the visitor accepts. */
export function loadAnalytics() {
  if (!GA4_ID || document.getElementById("ga4-script")) return;
  const s = document.createElement("script");
  s.id = "ga4-script";
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`;
  document.head.appendChild(s);
  gtag("js", new Date());
  gtag("config", GA4_ID, { anonymize_ip: true });
}

/** Track a conversion-style event (no-op without GA4). */
export function trackEvent(name, params = {}) {
  if (!GA4_ID) return;
  gtag("event", name, params);
}
